<template>
  <div>
    <section class="banner-part banner-top02 position-relative float-start w-100 bannerPart2">
      <div class="container">
        <div class="row row-cols-1 row-cols-lg-2 align-items-center g-5">
          <div class="col">
            <div class="text-white">
              <h2>捷捷AI<br> 您的日常助手
                <span class="wrap textBor">{{ typeText }}</span>
              </h2>
              <p class="my-4 my-lg-5 col-lg-9"> 新一代智能人机交互问答引擎，为用户提供更优质的体验，企业可以更专注于核心业务，而用户将获得更快速、更个性化的解决方案，从而提供更优质的服务体验。
              </p>
              <div class="d-flex align-items-center ">
                <a class="btn btn-more" data-bs-toggle="modal" data-bs-target="#registerModal">立即开始
                  <span class="btnImg">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-arrow-up-short" viewbox="0 0 16 16">
                      <path fill-rule="evenodd"
                        d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z">
                      </path>
                    </svg>
                  </span>
                </a>
              </div>
            </div>
          </div>
          <div class="col">
            <figure class="ritu-pic">
              <img alt="sui" src="static/static/picture/roubt.png">
            </figure>
          </div>
        </div>
      </div>
    </section>

    <main class="float-start w-100">
      <section class="top-features-div01">
        <div class="container">
          <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-5 g-lg-4">
            <div class="col">
              <div class="comon-itemsou d-inline-block w-100">
                <div class="d-flex align-items-center">
                  <span class="ivonm-ui">
                    <i class="fas fa-user-tie"></i>
                  </span>
                  <h5> 客服助理 <br> </h5>
                </div>
                <p>高效地与客户进行互动，并为他们提供快速准确的帮助，提升客户服务体验。
                </p>
              </div>
            </div>
            <div class="col">
              <div class="comon-itemsou d-inline-block w-100">
                <div class="d-flex align-items-center">
                  <span class="ivonm-ui">
                    <i class="fas fa-code"></i>
                  </span>
                  <h5>编程助手</h5>
                </div>
                <p> 协助开发人员代码编写、调试和优化，帮助开发人员提高编码效率和质量。
                </p>
              </div>
            </div>
            <div class="col">
              <div class="comon-itemsou d-inline-block w-100">
                <div class="d-flex align-items-center">
                  <span class="ivonm-ui">
                    <i class="fas fa-palette"></i>
                  </span>
                  <h5>AI 绘图 </h5>
                </div>
                <p> 帮助您创建基于文本的视觉，理解描述并生成相应的图像，辅助创作。
                </p>
              </div>
            </div>
            <div class="col">
              <div class="comon-itemsou d-inline-block w-100">
                <div class="d-flex align-items-center">
                  <span class="ivonm-ui">
                    <i class="fas fa-khanda"></i>
                  </span>
                  <h5>星座运势 </h5>
                </div>
                <p>提供更客观、科学的星座解读，帮助人们更好地理解自己的性格和行为特点。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="how-it-work d-inline-block w-100">
        <div class="container">
          <h6 class="text-center text-white subt-text"> 它是如何工作的？ </h6>
          <h2 class="text-center text-white main-head-text"> 使用步骤
            <br>
          </h2>
          <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-5 mt-5">
            <div class="col">
              <div class="comon-steps014 text-center d-inline-block w-100">
                <div class="noui">1</div>
                <figure class="mx-auto">
                  <img alt="sur" src="static/static/picture/signu.png">
                </figure>
                <h5 class="my-2"> 免费注册 </h5>
                <p class="mt-3" style="text-align: left;">用户通过填写手机号码，免费创建账号，注册后可享受特定的服务和权益。</p>
              </div>
            </div>

            <div class="col">
              <div class="comon-steps014 text-center d-inline-block w-100">
                <div class="noui">2</div>
                <figure class="mx-auto">
                  <img alt="sur" src="static/static/picture/undraw_Annotation_re_h774.png">
                </figure>
                <h5 class="my-2"> 聊天主题 </h5>
                <p class="mt-3" style="text-align: left;">在众多领域不同主题中，选择您感兴趣的聊天主题，从而进行与人类类似的对话交流。</p>
              </div>
            </div>

            <div class="col">
              <div class="comon-steps014 text-center d-inline-block w-100">
                <div class="noui">3</div>
                <figure class="mx-auto">
                  <img alt="sur" src="static/static/picture/undraw_Manage_chats_re_0yoj.png">
                </figure>
                <h5 class="my-2"> 描述问题</h5>
                <p class="mt-3" style="text-align: left;"> 使用简洁明了的语言表达您的问题，提供相关的背景信息关键点和需求，更好地理解您的问题。</p>
              </div>
            </div>

            <div class="col">
              <div class="comon-steps014 text-center d-inline-block w-100">
                <div class="noui">4</div>
                <figure class="mx-auto">
                  <img alt="sur" src="static/static/picture/undraw_Ideas_re_7twj.png">
                </figure>
                <h5 class="my-2">满意结果 </h5>
                <p class="mt-3" style="text-align: left;"> 聊天的发展也需要不断提升程序的对话能力、理解能力和情感识别能力，以更好地满足用户的需求。</p>
              </div>
            </div>
          </div>
        </div>

      </section>

      <section class="about-sru d-inline-block w-100">
        <div class="container">
          <div class="row row-cols-1 row-cols-lg-2 align-items-center g-5">
            <div class="col">
              <figure class="abu">
                <img alt="sm" src="static/static/picture/header-shape.ab54ecab.png">
              </figure>
            </div>
            <div class="col">
              <h6 class="subt-text">关于我们</h6>
              <h2 class="main-head-text text-white mt-3"> 开拓 创新 引领 <br> 专注于服务企业信息化领域 </h2>
              <p class="text-color">
                我们专注于企业信息化领域，致力于研究企业信息技术应用一体化方案、产品和服务。我们的使命是帮助各种行业的公司提高运营效益，提升企业核心竞争力。
              </p>
              <div class="comui-txet d-flex align-items-center mt-5">
                <figure>
                  <img alt="su" src="static/static/picture/7938341.png">
                </figure>
                <div class="texrt-divu ps-4">
                  <h5> 客户满意度 </h5>
                  <p> 感谢客户支持，我们的成功取决于您的满意度</p>
                </div>
              </div>
              <div class="comui-txet d-flex align-items-center">
                <figure>
                  <img alt="su" src="static/static/picture/3734860.png">
                </figure>
                <div class="texrt-divu ps-4">
                  <h5> 售后服务保障 </h5>
                  <p> 专业保障，让您放心，我们始终与您同在</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="whate-do d-inline-block w-100">
        <div class="container">
          <h6 class="text-center subt-text">我们可以做的</h6>
          <h2 class="text-center main-head-text text-white mt-3"> 一直努力，实现更多可能 <br> </h2>
          <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-5 mt-4">
            <div class="col">
              <div class="items-servics d-inline-block w-100">
                <figure>
                  <img alt="sy" src="static/static/picture/9390927.png">
                </figure>
                <h5> 写作助手 </h5>
                <p> 生成想法、故事、诗歌或文章，满足各种写作需求，包括文案、创意写作等。可以帮助你产生富有想象力的文本，为你的创意项目提供灵感和素材。</p>
              </div>
            </div>

            <div class="col">
              <div class="items-servics d-inline-block w-100">
                <figure>
                  <img alt="sy" src="static/static/picture/6663539.png">
                </figure>
                <h5> AI 绘画 </h5>
                <p>创意与技术的完美融合，为艺术家和观众带来了更多的创作灵感和参与体验，为艺术创作注入了更多的创新可能性，展现出了艺术与技术完美融合的新面貌。
                </p>
              </div>
            </div>

            <div class="col">
              <div class="items-servics d-inline-block w-100">
                <figure>
                  <img alt="sy" src="static/static/picture/4298077.png">
                </figure>
                <h5> 星座运势 </h5>
                <p> 根据个人的出生日期、星座信息以及其他相关因素，为用户生成针对性的星座运势分析报告，帮助用户更好地了解自己的特点和发展方向。</p>
              </div>
            </div>


            <div class="col">
              <div class="items-servics d-inline-block w-100">
                <figure>
                  <img alt="sy" src="static/static/picture/1356321.png">
                </figure>
                <h5> 编程开发 </h5>
                <p> 为程序员带来了更多的辅助和智能化工具，提高了开发效率和代码质量，为编程开发注入了更多的创新和可能性，革新了代码创作的方式和未来发展方向。</p>
              </div>
            </div>

            <div class="col">
              <div class="items-servics d-inline-block w-100">
                <figure>
                  <img alt="sy" src="static/static/picture/4207282.png">
                </figure>
                <h5> 情感识别 </h5>
                <p> 可以识别文本中的情感色彩，包括正面、负面或中性情绪。它可以帮助你分析用户反馈、社交媒体内容或产品评论等，了解情感趋势并作出相应决策。</p>
              </div>
            </div>

            <div class="col">
              <div class="items-servics d-inline-block w-100">
                <figure>
                  <img alt="sy" src="static/static/picture/81460.png">
                </figure>
                <h5> 学术论文 </h5>
                <p> 学术论文写作过程中一个重要辅助工具，帮助解决各种问题，提高论文质量；帮助收集相关文献并生成文献综述，快速了解所选课题领域的较新研究进展。</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="whate-do-cas d-inline-block w-100">
        <div class="container">
          <h6 class="text-center subt-text">用户案例</h6>
          <h2 class="text-center main-head-text text-white"> 各个行业领域的案例</h2>
          <div class="casty-slider owl-carousel owl-theme">
            <div class="items-case-01 d-inline-block w-100 position-relative">
              <div class="img-over">
                <img alt="ser" src="static/static/picture/sjfx.png">
              </div>
              <span class="btn btn-tognhu">数据分析</span>
              <div class="texr-divu">
                <h5>发掘洞察力的无限潜能 </h5>
                <p> 探索AI在数据分析领域的前沿应用，揭示数据背后的价值，助力企业智慧决策。实例剖析AI技术在市场趋势预测、用户行为分析和业务优化方面的成功案例，展现其无限潜能与巨大价值。</p>
              </div>
            </div>

            <div class="items-case-01 d-inline-block w-100 position-relative">
              <div class="img-over">
                <img alt="ser" src="static/static/picture/znjt.jpg">
              </div>
              <span class="btn btn-tognhu">智能交通</span>
              <div class="texr-divu">
                <h5> 智能交通领域的创新应用 </h5>
                <p> 探索AI在交通管理、自动驾驶和智能交通系统方面的前沿应用，剖析智能交通信号控制、交通流优化和交通事故预警等领域的成功案例，展现AI技术对交通运输行业的颠覆性影响。</p>
              </div>
            </div>

            <div class="items-case-01 d-inline-block w-100 position-relative">
              <div class="img-over">
                <img alt="ser" src="static/static/picture/znzz.jpg">
              </div>
              <span class="btn btn-tognhu">智能制造</span>
              <div class="texr-divu">
                <h5> 制造业的智能优化应用 </h5>
                <p> 揭示AI在生产计划优化、质量控制和设备维护等制造业领域的革新应用，剖析智能制造、预测性维护和智能供应链管理等方面的成功案例，推动制造业智能化转型升级。</p>
              </div>
            </div>

            <div class="items-case-01 d-inline-block w-100 position-relative">
              <div class="img-over">
                <img alt="ser" src="static/static/picture/znjy.jpg">
              </div>
              <span class="btn btn-tognhu">智能教育</span>
              <div class="texr-divu">
                <h5> 教育领域的个性化教学革命 </h5>
                <p> 解析AI在教育资源优化、个性化学习和智能教育辅助等领域的前沿应用，以实例展示智能教育平台、个性化教学内容推荐和学习行为分析等方面的成功案例，推动教育行业朝智能化方向迈进。</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="d-inline-block tetimonals-work-home-06 w-100">
        <div class="slider-tesr d-inline-block w-100">
          <div class="container">
            <div class="comon-heading">
              <h6 class="subt-text text-white"> 客户感言</h6>
              <h2 class="main-head-text text-white">我们的客户反馈</h2>
            </div>
            <div class="slider-testi-03 owl-carousel owl-theme">
              <div class="tems-slider01">
                <div class="para-details">
                  <p>
                    在心理测评方面的使用可以帮助心理健康领域提供更个性化、智能化的服务，提高心理治疗和干预的效果，促进个体的心理健康和幸福感。同时，也需要注意保护个体数据的隐私和安全。
                  </p>
                </div>
                <div class="d-flex align-items-center mt-4">
                  <div class="img-userpic">
                    <figure>
                      <img src="static/static/picture/usr3.jpg" alt="pnm">
                    </figure>
                    <div class="quite">
                      <i class="fas fa-quote-right"></i>
                    </div>
                  </div>
                  <h5 class="text-white"> 精神科主任
                    <span class="d-block">三甲医院, 成都</span>
                  </h5>
                </div>
              </div>
              <div class="tems-slider01">
                <div class="para-details">
                  <p>在金融领域的应用主要集中在风险控制和交易监测上，能够快速识别异常交易，提高交易安全性和效率。然而，过度依赖AI也可能导致对人为因素的忽视，需要慎重考虑。</p>
                </div>
                <div class="d-flex align-items-center mt-4">
                  <div class="img-userpic">
                    <figure>
                      <img src="static/static/picture/usr1.jpg" alt="pnm">
                    </figure>
                    <div class="quite">
                      <i class="fas fa-quote-right"></i>
                    </div>
                  </div>
                  <h5 class="text-white"> 资产管理者
                    <span class="d-block">金融租赁, 重庆 </span>
                  </h5>
                </div>
              </div>
              <div class="tems-slider01">
                <div class="para-details">
                  <p> 在制造业中发挥着重要作用，能够优化生产计划、提高生产效率，通过精准的需求预测和供应链管理，降低成本并提高生产质量。然而，AI在制造业应用中也面临设备数据接入和系统集成的挑战。</p>
                </div>
                <div class="d-flex align-items-center mt-4">
                  <div class="img-userpic">
                    <figure>
                      <img src="static/static/picture/usr2.jpg" alt="pnm">
                    </figure>
                    <div class="quite">
                      <i class="fas fa-quote-right"></i>
                    </div>
                  </div>
                  <h5 class="text-white"> 生产经理
                    <span class="d-block">汽车企业, 重庆 </span>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="d-inline-block faq-texr-div w-100">
        <div class="container">
          <h2 class="text-center main-head-text text-white">
            关于AI的常见问题？ 
            <br>
            我们有答案！ 
          </h2>
          <div class="col-lg-10 mx-auto">
            <div class="accordion mt-5" id="accordionExample">
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne">
                    数据隐私与安全问题
                  </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <p>
                      随着人工智能技术的迅速发展，数据隐私和安全问题成为了人们关注的焦点。
                    </p>
                    <p class="mt-2">
                      大量的数据被用于训练AI模型，但同时也面临着被滥用或泄露的风险。为了解决这一问题，企业需要采取严格的数据保护措施，包括加密技术、访问控制和数据匿名化等方法。此外，建立严格的数据管理流程和合规性监管也是保障数据安全的重要举措。
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo">
                    数据偏见和歧视
                  </button>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <p>
                      人工智能系统的决策可能存在数据偏见和歧视问题，特别是在使用历史数据进行训练时。
                    </p>
                    <p class="mt-2">这可能会导致系统对某些群体或个人做出不公平的决策。为了解决这一问题，企业需要审查数据集，采取措施消除偏见，并且持续监督和调整人工智能系统的决策过程，以确保公平性和平等对待。
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseThree">
                    法律和监管挑战
                  </button>
                </h2>
                <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <p>
                      人工智能的发展也引发了法律和监管方面的挑战。例如，如何确保人工智能系统的合法性和合规性，以及如何界定人工智能在法律责任和赔偿方面的地位等问题。
                    </p>
                    <p class="mt-2">为了解决这一问题，政府需要制定相关法律和监管政策，同时企业也需要遵守相关法规，确保人工智能系统的合法合规运行。</p>
                  </div>
                </div>
              </div>

              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapsefour">
                    技术可解释性
                  </button>
                </h2>
                <div id="collapsefour" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <p>
                      人工智能系统的决策过程通常是黑盒子，这给决策解释带来了挑战。
                    </p>
                    <p class="mt-2">
                      用户往往无法理解AI模型是如何做出决策的，这在一定程度上影响了用户对AI系统的信任度。为了解决这一问题，研究人员正在努力开发可解释的人工智能技术，以便用户能够理解系统的决策过程和依据，并加强对其进行监督和调整。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="d-inline-block getst-work-home-06 w-100">
        <div class="container position-relative">
          <FooterHint></FooterHint>
        </div>
      </section>

    </main>
  </div>
</template>

<script>
import FooterHint from '@/components/FooterHint';
// import { textList } from './text';
export default {
  name: '',
  components: {FooterHint},
  props: {},
  data() {
    return {
      fullText: '快速生成',
      typeText: '',
      isTyping: false,
      timeout: '',
      textList: ["角色定位", "智能问答", "快速生成"],
    }
  },
  computed: {},
  watch: {
    isTyping: {
      handler() {
        if (!this.isTyping) {
          clearTimeout(this.timeout)
          this.timeout = setInterval(this.loopText, 2000);
        }
      },
      immediate: true,
    },
    '$router.query.refresh':{
      immedidate:true, //立即执行
      handler:(val) => {
        console.log(val);
        if (val) {
          location.reload();
        }
      }
    },
  },
  created() {
  },
  mounted() {
    // 展示轮播图
    $('.casty-slider').owlCarousel({
        loop: true,
		autoplay:true,
        margin:30,
        nav: false,
	    dots:true,
        responsive: {
            0: {
                items:1
            },
            600: {
                items:1
            },
			768: {
                items:2
            },
            1000: {
                items:3
            }
        }
    });
    $('.slider-testi-03').owlCarousel({
		loop: true,
		margin:30,
		autoplay:true,
		nav:false,
		dots:true,
		responsive: {
		  0: {
			items:1
		  },
		  375: {
			items:1
		  },
		  600: {
			  items:1
		  },
		  667: {
			items:1
		  },
		  1000: {
			  items:1
		  },
		  1200: {
			items:2
		  }
	  
		}
	  })
  },
  methods: {
    // 实现打字机效果
    startTyping() {
      if (this.isTyping) return;
      this.isTyping = true;
      let index = 0;
      const interval = setInterval(() => {
        if (index <= this.fullText.length) {
          this.typeText = this.fullText.substring(0, index++);
        } else {
          clearInterval(interval);
          this.isTyping = false;
        }
      }, 200)
    },
    // 循环打字机效果
    loopText() {
      let index = this.textList.findIndex(item => item === this.fullText);
      if (index < this.textList.length - 1) {
        this.fullText = this.textList[++index];
      } else {
        this.fullText = this.textList[0];
      }
      this.startTyping();
    }
  },
  unmounted() {
    clearTimeout(this.timeout);
    clearInterval();
  },
}
</script>

<style scoped lang="less">
.textBor {
  border-right: 0.08em solid #fff;
}
.btnImg {
  svg {
    transform: rotate(45deg) scale(2) !important;
    padding-top: 8px;
    padding-left: 8px;
  }
} 
/* 轮播图 */
.carousel {
  -webkit-tap-highlight-color:transparent;
  position:relative;
  width: 100%;
  .owl-item {
    -webkit-tap-highlight-color:transparent;
    position:relative;
  }
}
@media screen and (max-width: 991px) and (min-width: 920px) {
  .bannerPart2 {
    height: 1000px;
  }
}
</style>
